import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  imports: [],
  templateUrl: './pagination.html',
  styleUrl: './pagination.css',
})
export class Pagination {
  @Input({ required: true }) page = 1;
  @Input({ required: true }) size = 10;
  @Input({ required: true }) totalPages = 0;
  @Input({ required: true }) totalElements = 0;

  @Input() first = true;
  @Input() last = true;
  @Input() hasNext = false;
  @Input() hasPrevious = false;

  @Output() pageChange = new EventEmitter<number>();

  get startItem(): number {
    if (this.totalElements === 0) {
      return 0;
    }

    return (this.page - 1) * this.size + 1;
  }

  get endItem(): number {
    return Math.min(
      this.page * this.size,
      this.totalElements
    );
  }

  previous(): void {
    if (!this.hasPrevious) {
      return;
    }

    this.pageChange.emit(this.page - 1);
  }

  next(): void {
    if (!this.hasNext) {
      return;
    }

    this.pageChange.emit(this.page + 1);
  }

  goTo(page: number): void {
    if (
      page < 1 ||
      page > this.totalPages ||
      page === this.page
    ) {
      return;
    }

    this.pageChange.emit(page);
  }

  get pages(): (number | string)[] {
    if (this.totalPages <= 5) {
      return Array.from(
        { length: this.totalPages },
        (_, i) => i + 1
      );
    }

    const current = this.page;

    if (current <= 3) {
      return [
        1,
        2,
        3,
        4,
        '...',
        this.totalPages
      ];
    }

    if (current >= this.totalPages - 2) {
      return [
        1,
        '...',
        this.totalPages - 3,
        this.totalPages - 2,
        this.totalPages - 1,
        this.totalPages
      ];
    }

    return [
      1,
      '...',
      current - 1,
      current,
      current + 1,
      '...',
      this.totalPages
    ];
  }
}
